import {faThumbsUp} from "@fortawesome/free-solid-svg-icons";

const likeIcon = faThumbsUp;

export default likeIcon;
